import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { useStores } from '@/components/StoreProvider'

import { PRIVACY_POLICY_URL } from './constants'

/** First-visit prompt. Accept and reject are deliberately the same size and style. */
export const CookieBanner = observer(() => {
  const { t } = useTranslation()
  const { consentStore } = useStores()

  if (consentStore.decided || consentStore.preferencesOpen) return null

  return (
    <div role="region" aria-label={t('consent.banner.title')} className="fixed inset-x-0 bottom-0 z-[1000] border-t border-gray-200 bg-white shadow-[0_-8px_30px_rgba(0,0,0,0.08)]">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-4 md:flex-row md:items-center md:gap-8 md:px-6">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-gray-900">{t('consent.banner.title')}</p>
          <p className="mt-1 text-sm leading-relaxed text-gray-600">
            {t('consent.banner.text')}{' '}
            <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className="font-medium text-[var(--color-primary)] underline underline-offset-2">
              {t('consent.privacy_policy')}
            </a>
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-center">
          <Button variant="ghost" onClick={() => consentStore.openPreferences()}>
            {t('consent.customise')}
          </Button>
          <Button variant="default" onClick={() => consentStore.rejectAll()}>
            {t('consent.reject_all')}
          </Button>
          <Button variant="default" onClick={() => consentStore.acceptAll()}>
            {t('consent.accept_all')}
          </Button>
        </div>
      </div>
    </div>
  )
})
CookieBanner.displayName = 'CookieBanner'
